export default __webpack_public_path__ + "static/media/Rectangle360.9d5f22af.png";